import { createContext } from 'react'

import { UserManagementFormContextType } from './types'

export const UserManagementFormContext = createContext<UserManagementFormContextType>(
  {} as UserManagementFormContextType,
)
